import { Map } from "mapbox-gl";

import circleGreen from "../../../assets/circleGreen.png";
import { CreateCirclePolygon } from "./Mappanel.part.ts";

import { RouteState } from "../../../api/edits/editRoute.responses.ts";
import {
  MapBoxGLMultiPolygon,
  MapBoxGLPoint,
  MapBoxGLPointData,
} from "../../../ts/interfaces/mapbox.interfaces.ts";

// pre:   - route has the route with focused sounds
//        - map has mapbox object on which to display
// post:  - map with displayed focused sounds
export function DisplayBackgroundSounds(map: Map, route: RouteState): void {
  let backgroundSoundCoords: MapBoxGLPointData =
    FillDataForBackgroundSounds(route);
  map.on("load", () => {
    // Add an image to use as a custom marker
    map.loadImage(circleGreen, (error, image) => {
      if (error) throw error;
      map.addImage("circleGreen", image as ImageBitmap);
      // Add a GeoJSON point sources
      map.addSource("points_background_sounds_source", {
        type: "geojson",
        data: backgroundSoundCoords as any,
      });
      // Add a symbol layer
      map.addLayer({
        id: "points_background_sounds",
        type: "symbol",
        source: "points_background_sounds_source",
        layout: {
          "icon-image": "circleGreen",
          "icon-size": 0.5,
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "text-allow-overlap": false,
          "text-optional": true,
          "text-field": ["get", "title"],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          "text-size": 14,
          "text-offset": [0.5, -0.5],
          "text-anchor": "bottom-left",
        },
        paint: {
          "text-color": "#202",
          "text-halo-color": "#fff",
          "text-halo-width": 1,
          "text-halo-blur": 1,
        },
      });
    });
  });
  let polygons: number[][][][] = [];
  // add range layers
  for (let i: number = 0; i < backgroundSoundCoords.features.length; ++i) {
    // create range polyline
    let polygonCoords: number[][] = CreateCirclePolygon(
      backgroundSoundCoords.features[i].geometry.coordinates,
      route.backgroundSounds[i].radius
    );
    polygons.push([polygonCoords]);
  }
  // create mapbox polygon
  map.on("load", () => {
    map.addSource("bs_polygon", {
      type: "geojson",
      data: {
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: polygons,
        },
      } as any,
    });
    // add a new fill layer
    map.addLayer({
      id: "bs_fill",
      type: "fill",
      source: "bs_polygon", // reference the data source
      layout: {},
      paint: {
        "fill-color": "#a2db9c", // green color fill
        "fill-opacity": 0.1,
      },
    });
    // add an outline layer
    map.addLayer({
      id: "bs_line",
      type: "line",
      source: "bs_polygon",
      layout: {},
      paint: {
        "line-color": "#116824",
        "line-width": 1,
      },
    });
  });
}
// pre:   route object with background sounds from which data is created
// post:  returns data with coordinates of background sounds
export function FillDataForBackgroundSounds(
  route: RouteState
): MapBoxGLPointData {
  let data: MapBoxGLPointData = {
    type: "FeatureCollection",
    features: [],
  };

  // loop through array of points
  for (const bs of route.backgroundSounds) {
    let point: MapBoxGLPoint = {
      type: "Feature",
      geometry: {
        type: "Point",
        // add geometry from route object
        coordinates: [bs.longitude, bs.latitude],
      },
      properties: {
        // add name
        title: bs.name,
      },
    };
    data.features.push(point);
  }

  return data;
}

// pre:   - route has the route with focused sounds
//        - map has mapbox object on which to display
// post:  - map layer background sounds has updated data
export function UpdateBackgroundSounds(map: Map, route: RouteState): void {
  if (map != null) {
    let backgroundSoundCoords: MapBoxGLPointData =
      FillDataForBackgroundSounds(route);
    let lay: any = map.getSource("points_background_sounds_source");
    if (lay !== undefined) {
      lay.setData(backgroundSoundCoords);
    }

    let polygons: number[][][][] = [];
    // create polygon data
    for (let i: number = 0; i < backgroundSoundCoords.features.length; ++i) {
      // create range polyline
      let polygonCoords: number[][] = CreateCirclePolygon(
        backgroundSoundCoords.features[i].geometry.coordinates,
        route.backgroundSounds[i].radius
      );
      polygons.push([polygonCoords]);
    }
    let layPoly: any = map.getSource("bs_polygon");
    if (layPoly !== undefined) {
      let geojson: MapBoxGLMultiPolygon = {
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: polygons,
        },
      };
      layPoly.setData(geojson);
    }
  }
}
